import FileManagerSelector from "../../../pages/fileManager2/selector/FileManagerSelector";
import {FileManagerTypes} from "../../../component/fileManager/FileManager";
import React, {useEffect, useState} from "react";
import {HttpClient} from "../../../service/httpClient/HttpClient";
import {changeContent, EditorItemType, prepareEditorItem} from "../RaikoCustomEditor2";
import "./InternalVideoSelector.scss"
import VideoPlayer from "../../../component/players/videoPlayer/VideoPlayer";
import videoType from "../image/video-type.svg"
import {DialogSize, RaikoDefaultDialogPage, RaikoSectionContainer} from "@moeindal/base-raiko-panel-components";

export default function InternalVideoSelector(
    {
        value = -1,
        priority,
        editorValue,
        setEditorValue,
        uid
    }
) {

    const [videoUrl, setVideoUrl] = useState("");

    useEffect(() => {
        if (typeof value !== "undefined" && value >= 0) {
            new HttpClient(
                {},
                "application/json",
                process.env.REACT_APP_BASE_URL
            )
                .get(
                    `files/${value}/urls/public`
                ).then(response => {
                setVideoUrl(response.streamUrl.replaceAll("http:", "https:"))
            }).catch(reason => {
                console.log("image not loading by reason ", reason)
            })
        } else {
            setVideoUrl("")
        }
    }, [value])


    const [galleryDialogOpenState, setGalleryDialogOpenState] = useState(false);

    function handleOpenFileManager() {
        setGalleryDialogOpenState(true)
    }

    function handleSelectVideo(id, url) {
        // setVideoUrl(url)

        changeContent(
            editorValue,
            setEditorValue,
            prepareEditorItem(id, EditorItemType.INTERNAL_VIDEO,uid),
            priority)
    }

    return (
        <>

            <RaikoDefaultDialogPage
                onClose={_ => {
                    setGalleryDialogOpenState(false)
                }}
                open={galleryDialogOpenState}
                dialogSize={DialogSize.LARGE}
                pageTitle={"ویدیو مورد نظر خود را انتخاب نمایید."}
            >
                <FileManagerSelector
                    setOpenDialog={setGalleryDialogOpenState}
                    bucketId={FileManagerTypes.VIDEO.id}
                    setSelectedFileUrl={handleSelectVideo}
                />

            </RaikoDefaultDialogPage>
            <div className={"baseAudioSelectorContainer"}>
                <RaikoSectionContainer
                    title={"ویدیو"}
                    hasActionButton
                    actionButtonOnclick={handleOpenFileManager}
                    actionButtonTitle={value && value > -1 ? "تغییر ویدیو" : "انتخاب ویدیو"}
                >

                    {videoUrl && videoUrl.length > 0 ?
                        <VideoPlayer file={videoUrl} className={"videoSelectorPreviewContainer"}/> :
                        <div
                            className={"videoNotSelectedContainer"}
                            onClick={handleOpenFileManager}
                        >

                            <img src={videoType} alt=""/>
                            <span>برای انتخاب ویدیو کلیک نمایید.</span>
                        </div>
                    }
                </RaikoSectionContainer>

            </div>
        </>

    )
}
